import { NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import Dashboard from 'portal/src/components/common/Dashboard';
import DataInsights from 'portal/src/components/summary/DataInsights';
import { DASHBOARD_SLUGS } from 'portal/src/constants/luzmoDashboards';

import { RouteDefinition } from './routeGenerator';

export const summaryRouteDefinitions: RouteDefinition[] = [
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.SUMMARY.HOMEPAGE} />,
    name: 'Portfolio',
    path: NESTED_ROUTES.SUMMARY.HOMEPAGE,
    description: 'A dynamic summary of key portfolio metrics',
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.SUMMARY.OPPENGINE} />,
    name: 'Savings Opportunities',
    path: NESTED_ROUTES.SUMMARY.OPPENGINE,
    description:
      'Analytics identified opportunities to save and improve performance',
  },
  {
    element: <DataInsights />,
    name: 'Data Insights',
    path: NESTED_ROUTES.SUMMARY.DATA_INSIGHTS,
    description: 'Analytics identified insights into data issues and anomalies',
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.SUMMARY.ENERGY_STAR} />,
    name: 'ENERGY STAR',
    path: NESTED_ROUTES.SUMMARY.ENERGY_STAR,
    description: 'ENERGY STAR scores and metrics',
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.SUMMARY.EMISSIONS} />,
    name: 'Emissions',
    path: NESTED_ROUTES.SUMMARY.EMISSIONS,
    description: 'Track scope 1 and scope 2 carbon emissions',
  },
  {
    element: (
      <Dashboard dashboardSlug={DASHBOARD_SLUGS.SUMMARY.DATA_COMPLETENESS} />
    ),
    name: 'Data Completeness',
    path: NESTED_ROUTES.SUMMARY.DATA_COMPLETENESS,
    description: 'Visualize how complete your data is by service type',
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.SUMMARY.DATA_RECENCY} />,
    name: 'Data Recency',
    path: NESTED_ROUTES.SUMMARY.DATA_RECENCY,
    description: 'Review how recent your bill data is by account',
  },
];
